module.exports = __webpack_public_path__ + "syria.svg?a610efa27e181ac5efc4f7c793264591";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/syria.svg
// module id = 312
// module chunks = 10